import { render, staticRenderFns } from "./JobEstimationsPanel.vue?vue&type=template&id=c70bf906"
import script from "./JobEstimationsPanel.vue?vue&type=script&lang=ts"
export * from "./JobEstimationsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports